import _toConsumableArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useMemo, useRef } from 'react';
import useSWR from 'swr';
import useSWRImmutable from 'swr/immutable';
import { deleteStreamHistory } from '@engage/api-v2';
import { engageApi } from '../lib/singletons';

var deleteStream = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(api, streamHistoryId) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!streamHistoryId) {
              _context.next = 4;
              break;
            }

            _context.next = 4;
            return deleteStreamHistory(api, streamHistoryId);

          case 4:
            _context.next = 8;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6]]);
  }));

  return function deleteStream(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var useDeleteStreamOnUnmount = function useDeleteStreamOnUnmount(api, streamHistoryId) {
  var deleteRef = useRef(); // Sync to ref so we have access during unmount without dependencies

  useEffect(function () {
    deleteRef.current = streamHistoryId;
  }, [streamHistoryId]);
  useEffect(function () {
    return function () {
      deleteRef.current && deleteStream(api, deleteRef.current);
    };
  }, []);
};
/**
 * @deprecated use toUseCreateAkamaiStream instead
 */


export var toUseGetStream = function toUseGetStream(StreamFetchers) {
  var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : engageApi;
  return function () {
    var _stream$data, _stream$data$streamHi, _stream$data2, _stream$data2$streamH;

    var currentStartTime = useMemo(function () {
      return new Date().toISOString();
    }, []);
    var stream = useSWRImmutable.apply(void 0, _toConsumableArray(StreamFetchers.CreateStream({
      currentStartTime: currentStartTime
    })));
    var streamHistoryId = (_stream$data = stream.data) === null || _stream$data === void 0 ? void 0 : (_stream$data$streamHi = _stream$data.streamHistory) === null || _stream$data$streamHi === void 0 ? void 0 : _stream$data$streamHi.id;
    useDeleteStreamOnUnmount(api, streamHistoryId);
    useSWR.apply(void 0, _toConsumableArray(StreamFetchers.Hearbeat({
      streamHistoryId: (_stream$data2 = stream.data) === null || _stream$data2 === void 0 ? void 0 : (_stream$data2$streamH = _stream$data2.streamHistory) === null || _stream$data2$streamH === void 0 ? void 0 : _stream$data2$streamH.id
    })));
    return stream;
  };
};
export var toUseCreateAkamaiStream = function toUseCreateAkamaiStream(StreamFetchers) {
  var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : engageApi;
  return function (_ref2) {
    var _stream$data3;

    var rideId = _ref2.rideId,
        contentType = _ref2.contentType;
    var currentStartTime = useMemo(function () {
      return new Date().toISOString();
    }, []);
    var stream = useSWRImmutable.apply(void 0, _toConsumableArray(StreamFetchers.CreateAkamaiStream({
      currentStartTime: currentStartTime,
      rideId: rideId,
      contentType: contentType
    })));
    var streamHistoryId = (_stream$data3 = stream.data) === null || _stream$data3 === void 0 ? void 0 : _stream$data3.streamHistoryId;
    useDeleteStreamOnUnmount(api, streamHistoryId);
    useSWR.apply(void 0, _toConsumableArray(StreamFetchers.Hearbeat({
      streamHistoryId: streamHistoryId
    })));
    return stream;
  };
};